import Tabs from "./Tabs.vue";
import TabItem from "./TabItem.vue";
import { pluginify } from "./../../util";
export default pluginify(Tabs, TabItem);
export { Tabs, TabItem };
